module.exports = __webpack_public_path__ + "img/request.de9a1a0f.svg";